export default __webpack_public_path__ + "img/fc672ec353e117a89fcf46ddb3fc78cf.svg";